//
// CommonsUIPackage.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "./moduleBuilder";
import ClosetObject from "./ClosetObject";
import "./PortablePackage";

var CommonsUIPackage = createModule("commons::CommonsUIPackage", ["commons::PortablePackage"], ClosetObject, [
    ,
    ,
    ,
    ,
    ,
    {
        instance: [1],
        TOGGLE_ON_TAP: [7],
    },
    ,
]);
export default CommonsUIPackage;
